{
  "account": {
    "title": "Oma tili",
    "list": {
      "title": "Tilit",
      "description": "Linkitettyjen tilien laskutusluettelo"
    },
    "form": {
      "name": {
        "title": "Nimi",
        "description": "Tilisi nimi"
      },
      "password": {
        "title": "Salasana",
        "description": "Aseta uusi salasana tilillesi; jätä tyhjäksi säilyttääksesi nykyisen salasanan"
      },
      "emailPreferences": {
        "title": "Sähköpostiasetukset",
        "description": "Valitse sähköposti-ilmoitustyypit"
      }
    },
    "billing": "Laskutustiedot",
    "subscriptions": "Tilaukset",
    "manageSubscription": "Hallinnoi tilausta",
    "popup": {
      "cancel": "Haluatko varmasti peruuttaa tilauksesi?<br/>Verkkosivustosi jatkaa kääntämistä nykyisen tilausjakson loppuun asti. Tämän jälkeen kääntäminen poistetaan käytöstä.<br/>Huomaathan, ettet ole oikeutettu hyvitykseen käyttämättä jääneestä jaksosta.",
      "downgrade": "Haluatko varmasti siirtyä alempaan tasoon? Muutos astuu voimaan välittömästi.<br/>Huomaathan, ettet ole oikeutettu hyvitykseen kuluvan laskutusjakson jäljellä olevasta ajasta.<br/>Uusi suunnitelman hinta astuu voimaan seuraavalla laskutusjaksolla.",
      "default": "Haluatko varmasti muuttaa suunnitelmaasi?",
      "resume": "Haluatko varmasti jatkaa tilaustasi?"
    }
  },
  "ai_translation": {
    "header": "Käännös tekoälyllä",
    "plan": {
      "header": "Käännös tekoälyllä – hinnoittelu",
      "used": "Olet käyttänyt {words_used} / {words_allowed} käännettyä sanaa tekoälykrediiteissäsi.",
      "remaining": "Saatavilla olevat tekoälykrediitit:",
      "words": "sanaa",
      "add_more_credits": "Lisää tekoälykrediittejä",
      "details": {
        "idiomatic_expressions": "Idiomaattiset ja tekniset ilmaisut",
        "background_translation": "Taustalla tapahtuvat käännökset",
        "best_website": "Vieraille, jotka vaativat täydellistä käännösten laatua",
        "page_context": "Sivun ja verkkosivuston konteksti kääntämisessä",
        "perfect_quality": "Täydellinen laatu, edullinen hinta",
        "no_recurring": "Ei toistuvia maksuja, etukäteen maksettu kiintiö",
        "save_40": "Säästä 40 % verrattuna 20 $:n suunnitelmaan",
        "save_50": "Säästä 50 % verrattuna 20 $:n suunnitelmaan"
      },
      "quota": "{estimated_words} sanaa ~ {estimated_pages} sivua"
    },
    "settings": {
      "banner": {
        "title": "Linguise Käännös tekoälyllä",
        "intro": "Linguise esittelee Linguise Käännös tekoälyllä - uuden premium-ominaisuuden, joka hyödyntää tekoälyn LLM-malleja (uusimpia Llama-malleja, optimoitu käännöstehtäviin). Se on suunniteltu verkkosivustoille, jotka vaativat virheetöntä tarkkuutta ja ottaa huomioon sekä sivun että koko sivuston kontekstit saavuttaakseen vertaansa vailla olevan laadun. Tarjoa asiakkaillesi huipputehokas käännöslaatu ja varmista, että heidän viestinsä välittyy täydellisesti jokaisella kielellä.",
        "button": "Päivitä nyt"
      },
      "alert": {
        "description": "Tämä ominaisuus ei sisälly nykyiseen suunnitelmaasi ja vaatii erillisen oston.\nAktivoi tämä lisäosa avataksesi kaikki alla luetellut vaihtoehdot."
      },
      "languages": {
        "title": "Käytä käännös tekoälyllä kielissä",
        "description": "Valitse tietyt kielet, joihin haluat AI-käännöksen kohdistuvan"
      },
      "button": {
        "save": "Tallenna asetukset"
      },
      "form": {
        "advanced": {
          "title": "Lisämääräykset tekoälylle",
          "description": "Lisämääräykset tekoälylle"
        },
        "enable_mode": {
          "title": "OTA KÄÄNNÖS TEKOÄLYLLÄ KÄYTTÖÖN",
          "description": "Valitse, miten haluat AI-käännöksen otettavan käyttöön.\nVain säännöt soveltaa seuraavia sääntöjä.\nVain live-editori mahdollistaa sivukohtaisen käännöksen live-editorinäkymästä.\nSäännöt ja live-editori käyttävät molempia ominaisuuksia.",
          "disabled": "Pois käytöstä",
          "rules": "Vain säännöt",
          "live_editor": "Vain live-editori",
          "all": "Säännöt ja live-editori"
        },
        "rule_application": {
          "description": "Käytä AI-käännöstä staattiseen sisältöön, dynaamiseen sisältöön tai molempiin",
          "title": "Käytä sisältöön",
          "all": "Kaikki sisältö",
          "static": "Staattinen sisältö",
          "dynamic": "Dynaaminen sisältö"
        },
        "website_topic": {
          "title": "Verkkosivuston aihe",
          "placeholder": "Sushiravintola…",
          "description": "Määritä verkkosivustosi aihe paremman käännöslaadun saavuttamiseksi (esim. juridiikka, sushiravintola, polkupyöräosien verkkokauppa…)\nAnna aihe englanniksi."
        },
        "apply_to_urls": {
          "title": "Käytä URL-osoitteisiin",
          "description": "Valitse tietyt URL-osoitteet, joihin haluat AI-käännöksen kohdistuvan",
          "all_urls": "Kaikki osoitteet",
          "selected_urls": "Valitut osoitteet",
          "label": "Kohde-URL",
          "placeholder": "Kohde-URL",
          "wildcard": "Jokerimerkki",
          "regex": "Säännöllinen lauseke",
          "add": "Lisää uusi",
          "expression": "Lausekkeen tyyppi"
        },
        "apply_languages": {
          "title": "Käytä kieliin",
          "description": "Valitse tietyt kielet, joihin haluat AI-käännöksen kohdistuvan",
          "all_languages": "Kaikki kielet",
          "selected_languages": "Valitut kielet",
          "placeholder": "Valitse kielet…",
          "feedback": "Sinun täytyy valita vähintään yksi kieli"
        },
        "formality": {
          "title": "Muodollisuusaste",
          "description": "Aseta käännösten muodollisuus – voi olla tärkeä kohderyhmän ja kontekstin kannalta.\n\"Neutraali\" pyrkii säilyttämään alkuperäisen sisällön muodollisuuden.\n\"Muodollinen\" on tarkoitettu ammatti-, liike- tai oikeuskäyttöön (esim. espanjan \"usted\").\n\"Epämuodollinen\" on tuttuun, keskustelevaan tyyliin (esim. espanjan \"tú\").",
          "neutral": "Neutraali",
          "formal": "Muodollinen",
          "informal": "Epämuodollinen"
        },
        "sentence_structure": {
          "classic": "Klassinen",
          "short": "Lyhyet ja iskevät lauseet",
          "detailed": "Yksityiskohtaiset ja selittävät lauseet",
          "title": "Lauseen rakenne",
          "description": "Määrittele kirjoitustyylitoive."
        },
        "content_purpose": {
          "marketing": "Markkinointi/promo (suostutteleva, sitouttava sävy)",
          "technical": "Tekninen/ohjeistava (selkeä, täsmällinen, toimintasuuntautunut)",
          "support": "Asiakaspalvelu (empaattinen, avulias, kannustava)",
          "legal": "Lainsäädäntö/oikeudellinen (tarkka, muodollinen, yksiselitteinen)",
          "educational": "Opetuksellinen (selkeä, jäsennelty, saavutettava)",
          "other": "Muu (englanniksi)",
          "title": "Sisällön tarkoitus",
          "description": "Määrittele käännettävän sisällön toiminnallinen tavoite.",
          "other_placeholder": "Kuvaile tarkoitus…"
        },
        "target_audience": {
          "title": "Kohderyhmä",
          "description": "Käännettävän sisällön kohderyhmän kuvaus (englanniksi).",
          "placeholder": "esim. espanjankieliset vanhemmat, EU:n tietosuojavaltuutetut"
        },
        "override_default_translations": {
          "title": "Ohita oletuskaannös",
          "description": "Jos KYLLÄ, sisältö käännetään AI:lla (Linguise AI) vaikka se olisi jo käännetty pilvi-AI:lla (oletusmalli)."
        },
        "force_replace_before": {
          "title": "Pakota tekoälykäännös uudelleen",
          "description": "Käännä tekoälyllä uudelleen kaikki sisältö, jonka tekoälykäännös tehtiin ennen valittua päivämäärää, esimerkiksi vanhemmalla mallilla käännetty sisältö. Uudelleenkäännös tehdään sääntöjen mukaisten sivujen seuraavalla käyntikerralla, ja se käyttää tekoälysaldoasi.",
          "before_date": "Ennen päivämäärää"
        },
        "model": {
          "current": "Nykyinen",
          "title": "Malli",
          "description": "Valitse haluamasi LLM-käännösmalli",
          "load_error": "Saatavilla olevia malleja ei voitu ladata. Yritä uudelleen myöhemmin.",
          "thinking_warning": "Tämä malli käyttää korkeaa päättelytasoa (\"ajattelu\") ja kuluttaa huomattavasti enemmän merkkejä käännöstä kohden."
        },
        "override_manual_and_selected": {
          "no_default": "Ei (oletus)",
          "title": "Korvaa manuaaliset ja valitut käännökset",
          "description": "Oletuksena itse muokkaamasi käännös pysyy aina verkkosivustollasi, vaikka tekoälyllä parannettu käännös olisi luotu. Valitse KYLLÄ, jos haluat näyttää sen sijaan tekoälyllä parannetun käännöksen. Manuaaliset käännöksesi säilyvät, ja voit vaihtaa takaisin milloin tahansa. Tämä vaikuttaa myös silloin, kun käännät sivut uudelleen saadaksesi uusia käännöksiä; uusin käännös otetaan automaattisesti käyttöön."
        }
      },
      "message": {
        "save_success": "Nykyisistä jo käännettyyn sisältöön kohdistuvista sivuista arviolta {{ai_affected_urls}} sivua voidaan parantaa AI-käännöksellä.",
        "save_success_only": "Asetukset tallennettu onnistuneesti."
      }
    },
    "pricing": {
      "plan": {
        "title": "Tilaa AI-käännös-kiintiö",
        "buy_button": "OSTA AI-KÄÄNNÖSPAKETTI"
      },
      "modal": {
        "title": "Vahvista suunnitelmanvaihto",
        "description": "Haluatko varmasti muuttaa AI-käännössuunnitelmaasi?",
        "button_cancel": "Peruuta",
        "button_confirm": "Vahvista",
        "loading": "Odota hetki...",
        "amount": "Määrä",
        "credit": "Krediitti",
        "total_due": "Maksettava yhteensä"
      },
      "comparison": {
        "title": "Google Cloud AI -käännös\nvs Linguise AI -käännös",
        "list": {
          "0": {
            "google": "Nopeat ja luotettavat käännökset",
            "linguise": "Käsittelee idiomaattiset ja tekniset ilmaisut"
          },
          "1": {
            "google": "Kaikkien verkkosivujen välittömät käännökset",
            "linguise": "Käännösten luonti taustalla"
          },
          "2": {
            "google": "Paras laatu, edullinen hinta",
            "linguise": "Täydellinen laatu, kohtuullinen hinta"
          },
          "3": {
            "google": "Paras vaihtoehto suurille verkkosivuille tai pienelle budjetille",
            "linguise": "Paras verkkosivuille, jotka vaativat täydellistä käännöslaatua"
          },
          "4": {
            "google": "Sivun konteksti käännöstä varten",
            "linguise": "Sivun ja verkkosivun konteksti käännöstä varten"
          }
        }
      },
      "botom_banner": {
        "title": "Koe vertaansa vailla oleva käännöstarkkuus",
        "sub_title": "Uusi Linguise AI -käännös",
        "description": "Linguise parantaa automaattisia käännöspalveluitaan esittelemällä Linguise AI -käännöksen, tehokkaan uuden vaihtoehdon, joka hyödyntää huippuluokan AI-käännös LLM:ää (uusimpia Llama-malleja, jotka on optimoitu käännöksiin). Tämä lisäys tarjoaa verkkosivujen kehittäjille ja verkkotoimistoille vieläkin korkeamman käännöslaatutason, ihanteellinen projekteihin, joissa täydellisyys on ratkaisevaa. Linguise AI -käännös täydentää olemassa olevaa, laadukasta Google Cloud AI -käännöstä tarjoten sinulle entistä enemmän joustavuutta ja tarkkuutta."
      }
    },
    "success": {
      "tab_title": "Kiitos, että ostit AI-käännössuunnitelman!",
      "title": "Kiitos, että ostit AI-käännössuunnitelman!",
      "subtitle": "AI-käännössuunnitelmasi on ostettu onnistuneesti!",
      "message": "Voit hallita AI-käännössuunnitelmaasi AI-käännösasetussivulla.",
      "home": "Hallitse AI-käännöstä"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Nimi",
        "description": "Laskutustilin nimi"
      },
      "phone": {
        "title": "Puhelin",
        "description": "Laskutustilin puhelinnumero"
      },
      "email": {
        "title": "Sähköposti",
        "description": "Laskutustilin sähköposti"
      },
      "address": {
        "title": "Osoite",
        "description": "Laskutustilin osoite",
        "city": "Kaupunki",
        "country": "Maa",
        "address1": "Osoite 1",
        "address2": "Osoite 2",
        "postal": "Postinumero",
        "state": "Osavaltio"
      },
      "tax": {
        "title": "Veronumero"
      }
    }
  },
  "checkouts": {
    "header": "Kassa",
    "payment_method": "Valitse maksutapa",
    "stripe_card": "Luottokortti (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Anna uusi laskutusosoite",
      "existing": "Käytä olemassa olevaa osoitetta"
    },
    "pay_stripe": "Vahvista ja maksa",
    "terms": "Vahvistamalla tilauksesi annat Linguiselle luvan veloittaa sinua tulevista maksuista käyttöehtojemme mukaisesti. Voit peruuttaa tilauksesi milloin tahansa.",
    "coupon": {
      "title": "Onko sinulla kuponki?",
      "placeholder": "Liitä kuponkikoodi tähän",
      "apply": "Käytä",
      "percent": "{{0}} % alennus"
    },
    "add_new": "Lisää uusi",
    "use_existing": "Käytä olemassa olevaa maksutapaa",
    "recurring": {
      "month_single": "Laskutetaan kuukausittain",
      "month_many": "Laskutetaan joka {{count}} kuukausi",
      "year_single": "Laskutetaan vuosittain",
      "year_many": "Laskutetaan joka {{count}} vuosi",
      "day_single": "Laskutetaan päivittäin",
      "day_many": "Laskutetaan joka {{count}} päivä",
      "week_single": "Laskutetaan viikoittain",
      "week_many": "Laskutetaan joka {{count}} viikko"
    },
    "add_new_no_stripe": "Lisää uusi kortti",
    "summary": {
      "title": "Yhteenveto",
      "subtotal": "Välisumma",
      "total": "Yhteensä"
    }
  },
  "dashboard": {
    "main": {
      "title": "Hallintapaneeli"
    },
    "statistics": {
      "main_title": "Tilastot viimeiseltä 30 päivältä",
      "characters": "Käännettyjä merkkejä",
      "words": "Käännettyjä sanoja",
      "bandwidth": "Syöttökaista",
      "request": "Pyynnöt",
      "page_views": "Sivunäkymät kieleittäin (viimeiset 30 päivää)",
      "multilingual_views": "Monikieliset sivunäkymät (viimeiset 30 päivää)",
      "most_page_viewed": "20 katsotuinta sivua (viimeiset 30 päivää)",
      "no_data_yet": "Tietoja ei ole vielä saatavilla",
      "th_language": "Kieli",
      "th_page_views": "Sivunäkymät",
      "real_visitors": "Todelliset kävijät",
      "crawler": "Verkkorobotti"
    },
    "planHints": {
      "subscribeButton": "Tilaa",
      "upgradeButton": "Päivitä",
      "usedWords": "Käytät tällä hetkellä {words_used} sanaa",
      "noPlan": "Tälle verkkotunnukselle ei ole aktivoitu suunnitelmaa. Tilaa suunnitelma ja aloita verkkosivujen kääntäminen",
      "noPlanShopify": "Tälle verkkotunnukselle ei ole aktivoitu suunnitelmaa. Tilaa suunnitelma Shopify-hallintapaneelistasi ja aloita verkkosivujen kääntäminen",
      "trialUsage": "Käytät tällä hetkellä {words_used} sanaa kokeilusuunnitelman {words_allowed} sanasta.",
      "trialEnds": "Ensimmäisen kuukauden kokeilu on aktivoitu {trial_ends} asti.",
      "subscribeMessage": "Tilaa ennen sen päättymistä, jotta verkkosivustosi pysyy käännettynä",
      "subscribeMessageShopify": "Tilaa Shopify-hallintapaneelistasi ennen sen päättymistä, jotta verkkosivustosi pysyy käännettynä",
      "trialReachedLimit": "Olet saavuttanut enimmäiskäännettyjen sanojen määrän kokeilujaksolla.\nTilaa yksi suunnitelmistamme jatkaaksesi verkkosivujen kääntämistä.",
      "paidUsage": "Olet käyttänyt {words_used} / {words_allowed} käännettyä sanaa suunnitelmassasi.",
      "paidReachedLimit": "Olet saavuttanut nykyisen suunnitelman enimmäiskäännettyjen sanojen määrän.\nPäivitä suunnitelmasi jatkaaksesi verkkosivujen sisällön kääntämistä.",
      "trialOfferedUsage": "Käytät tällä hetkellä {words_used} sanaa kokeilusuunnitelman {words_allowed} sanasta (mukaan lukien {free_words} tarjottua sanaa).",
      "paidOfferedUsage": "Olet käyttänyt {words_used} / {words_allowed} käännettyä sanaa suunnitelmassasi (mukaan lukien {free_words} tarjottua sanaa).",
      "noPlanExtra": "Huomaa, että epäaktiiviset verkkotunnukset ja niiden tiedot poistetaan automaattisesti säännöllisesti.",
      "planRecommended": "Nykyisen käännösvolyymisi perusteella suositeltu suunnitelma on:",
      "planMaximumWords": "{{words}} sanaa",
      "notHaveTranslatedWords": "Et ole vielä tehnyt yhtään käännöstä"
    },
    "translationSetup": {
      "kicker": "ALIVERKKOTUNNUKSEN ASETUS",
      "title": "Tarkista käännösasetukset",
      "description": "Tarkista DNS, käännetyt palvelimet, pääsy alkuperäiselle sivustolle ja tilin rajoitukset.",
      "starting": "Tarkistetaan...",
      "button": "Tarkista asetukset",
      "viewLatest": "Näytä viimeisin tulos",
      "viewCurrent": "Näytä nykyinen tarkistus",
      "runAgain": "Suorita tarkistus uudelleen",
      "viewDetails": "Näytä tiedot",
      "hideDetails": "Piilota tiedot",
      "error": "Asetusten tarkistus ei onnistu",
      "allPassed": "Kaikki tarkistukset läpäisty",
      "setupNeedsAttention": "Asetukset vaativat huomiota",
      "setupNeedsAttentionDescription": "Yksi tai useampi tarkistus epäonnistui. Tarkista alla olevat kohdat tai ota yhteyttä Linguise-tukeen.",
      "lastChecked": "Tarkistettu viimeksi {{time}}",
      "domainOwnership": "Verkkotunnuksen omistajuus",
      "domainOwnershipDescription": "Vahvistustietue löytyi",
      "domainOwnershipFailure": "Omistajuuden DNS-tietuetta ei voitu vahvistaa.",
      "translatedHosts": "Käännetyt palvelimet",
      "translatedHostsDescription": "Tarkistettu {{count}} kielipalvelinta",
      "translatedHostsFailure": "Yksi tai useampi kielen CNAME-tietue on virheellinen.",
      "subdomainPage": "Aliverkkotunnuksen sivu",
      "subdomainPageDescription": "{{count}} käännettyä sivua hyväksyy HTTPS-yhteyden",
      "subdomainPageFailure": "TLS-yhteys epäonnistui avattaessa yhtä tai useampaa käännettyä sivua.",
      "originalSite": "Alkuperäinen sivusto",
      "originalSiteDescription": "Alkuperäisen sivuston DNS-, TLS- ja vastaustarkistukset",
      "originalSiteFailure": "Alkuperäisen sivuston DNS-, TLS- tai vastaustarkistus epäonnistui.",
      "documentationAdvice": {
        "dns": "Tarkista DNS-asetukset",
        "tls": "Tarkista HTTPS-asetukset",
        "origin": "Tarkista alkuperäisen sivuston asetukset",
        "diagnostic": "Katso vianmääritysohjeet"
      },
      "evidence": {
        "originDns": "Alkuperäinen DNS",
        "originTls": "Alkuperäinen TLS",
        "originHttp": "Alkuperäinen vastaus",
        "observedTargets": "Havaitut kohteet",
        "recordCount": "Tietueita löytyi",
        "addressCount": "Osoitteita löytyi",
        "statusCode": "HTTP-tila",
        "redirect": "Uudelleenohjaus",
        "expiresAt": "Varmenteen voimassaolo päättyy",
        "raw": "{{key}}",
        "noValue": "Ei arvoa"
      },
      "checkerError": "Kaikkia tarkistuksia ei voitu suorittaa.",
      "coreLocation": "Tarkistettu sijainnista {{location}}",
      "status": {
        "queued": "Jonossa",
        "running": "Käynnissä",
        "completed": "Valmis",
        "failed": "Epäonnistui",
        "passed": "Läpäisty",
        "warning": "Varoitus",
        "unknown": "Tuntematon",
        "skipped": "Ohitettu",
        "not_applicable": "Ei sovellu"
      }
    },
    "throttling": {
      "title": "Käännösrajoitus",
      "description": "Tilapäiset käyttörajoitukset",
      "unavailable": "Tilapäiset käännösrajoitukset eivät ole käytettävissä",
      "window": "{{used}} / {{max}} sanaa",
      "resetsIn": "Nollautuu {{time}} kuluttua",
      "throttled": "Käännös keskeytetty tilapäisesti",
      "throttledDescription": "Tilapäinen käyttöraja on saavutettu. Käännös jatkuu, kun tämä jakso nollautuu."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "VAIHE {{step}} / {{total}}",
      "doneLabel": "VALMISTA, VOIT ALOITTAA KÄÄNTÄMISEN!",
      "finish": {
        "title": "",
        "description": "Tämä on API-avain, jota käytetään verkkosivustollasi"
      },
      "instructions": "Asennusohjeet",
      "domainSetting": "Verkkotunnuksen asetus",
      "step": {
        "titleWordpress": "WordPress",
        "titleJoomla": "Joomla",
        "titlePHP": "PHP-skripti",
        "wizardWordpressStep1": "1. Asenna ",
        "wizardWordpressStep2": "\n 2. Kopioi ja liitä API-avaimesi liitännäisen asetuksissa\n",
        "wizardWordpressStep3": "3. Olet valmis kääntämään\n\n",
        "wizardWordpressStep4": "Yksityiskohtaisempia ohjeita varten tutustu dokumentaatioomme: ",
        "wizardJoomlaStep1": "1. Joomla-paketin linkki: ",
        "wizardJoomlaStep2": "\n2. Kopioi API-avain ja syötä se laajennuksen asetuksissa",
        "wizardJoomlaStep3": "3. Aseta moduulissa haluamasi kielet ja sijoita moduuli tarvittavaan paikkaan.",
        "wizardJoomlaStep4": "\n4. Olet valmis kääntämään\n\n",
        "wizardPhpStep1": "1. Lataa php-skriptimme täältä ",
        "wizardPhpStep2": "\n2. Noudata asennusohjeita dokumentaatiossamme täällä ",
        "wizardPhpStep3": "\n3. Lisää moduuli sivuillesi.",
        "wizardPhpStep4": "\n Kopioi seuraava koodi ja liitä se html-sivusi head-osioon; se näyttää vaihtajamoduulin automaattisesti\n",
        "dispatchStep1": "Lähetimme vaaditut tiedot Linguise-lisäosalle onnistuneesti, voit sulkea seuraavan ikkunan nyt.",
        "dispatchStep2": "Jos tunnus puuttuu sulkiessasi tämän ikkunan, kopioi seuraava tunnus:",
        "dispatchStep3": "Voit myös kopioida tämän koodin, jotta lippuvaihdin otetaan automaattisesti käyttöön",
        "wizardOtherStep1": "Seuraa alla olevia ohjeita asentaaksesi Linguise verkkotunnuksellesi.\n",
        "wizardOtherStep2": "Kopioi seuraava koodi ja lisää se html-sivusi head-osioon; se näyttää vaihtajamoduulin automaattisesti.\n"
      },
      "trialAlreadyUsed": "Vaikuttaa siltä, että olet jo käyttänyt ilmaisen kokeilusi, joten tarvitset käännöskiintiön\nTilaa suunnitelma tai ota meihin yhteyttä, jos haluat jatkaa kokeilua.",
      "usefulLinks": "Hyödyllisiä linkkejä alkuun pääsemiseksi",
      "linkDocumentation": "Dokumentaatio",
      "linkExtensionDl": "Lisäosan lataus",
      "linkSubscribe": "Tilaa suunnitelma nyt",
      "linkDashboard": "Siirry hallintapaneeliin",
      "exclusion": {
        "title": "Yritysten ja tuotteiden nimet",
        "description": ""
      },
      "finishButton": "Viimeistele asennus",
      "subdomains": "Aliverkkotunnukset",
      "subdomain_setup": "Aseta verkkotunnus",
      "subdomain_auto_setup": "Yhdistä DNS automaattisesti",
      "subdomain_manual_setup": "Lisään DNS-tietueet itse",
      "subdomain_skip": "Tee myöhemmin",
      "auto_subdomains_info": "Sivustonrakentajasi CMS vaatii DNS-määrityksen kielien asettamiseksi ali-verkkotunnuksittain (esim. fi.domain.com).",
      "auto_subdomains_info_2": "Voit tehdä sen automaattisesti Entri-palvelulla. Napsauta \"Yhdistä DNS automaattisesti\" -painiketta muodostaaksesi yhteyden DNS-hallintaasi ja lisätäksesi ne Entrillä.",
      "auto_subdomains_info_manual": "Tai voit määrittää verkkotunnuksen manuaalisesti napsauttamalla \"Lisään DNS-tietueet itse\" -painiketta.",
      "breadcrumbs": {
        "step1": "Vaihe 1: Verkkotunnus, sisällönhallintajärjestelmä ja kielet",
        "step2": "Vaihe 2: Kieli-DNS",
        "step3": "Vaihe {{step}}: Asennusohjeet"
      }
    },
    "form": {
      "urls": {
        "dash": "Viiva -",
        "underscore": "Alaviiva _",
        "title": "Käännä URL-osoitteet",
        "description": "Haluatko kääntää kaikilla sivuilla",
        "char_description": "Merkki, jolla korvataan kielletyt merkit URL-osoitteissa",
        "advertisement_title": "⚠ Olet asettanut paljon kieliä.\n",
        "advertisement": "Suosittelemme yleensä aloittamaan verkkosivuston kääntämisen aluksi muutamalla kielellä. Saat käsityksen, kuinka monta sanaa sivustollasi on. Se on myös parempi SEO:n kannalta, sillä Google-bottien indeksointi on nopeampaa, jos aluksi on vähemmän sivuja. Viikon kuluttua voit lisätä muutamia kieliä lisää ja niin edelleen."
      },
      "url": {
        "title": "URL",
        "description": "Aseta pääverkkotunnuksesi URL-osoite alkaen http:// tai https://",
        "placeholder": "Verkkotunnuksen URL",
        "advertisement_http": {
          "title": "Et käytä https-protokollaa",
          "description": "Tarkista, ettei verkkotunnuksesi käytä https-protokollaa, mikä nykyään on suositeltavaa."
        },
        "advertisement_www": {
          "title": "Ali-verkkotunnuksesi ei ole www",
          "description": "Useimmiten oletusali-verkkotunnus on www (esim. https://www.mydomain.com). Tämä ei ehkä päde sinun tapaukseesi, mutta varmista, että lisättävä verkkotunnus on oikea."
        },
        "invalid_url": {
          "line1": "Emme löytäneet verkkotunnustasi. Tarkista, että se on julkisesti Internetin kautta saatavilla eikä ohjaa toiseen sijaintiin.",
          "line2": "Jos olet varma, että verkkotunnus on saatavilla, voit ohittaa verkkotunnuksen vahvistuksen ja painaa \"Seuraava vaihe\" -painiketta uudelleen",
          "contact": "Voit tarvittaessa ottaa meihin yhteyttä osoitteeseen",
          "force": "Ohita verkkotunnuksen vahvistus"
        },
        "invalid_subdomain_url": "Tätä URL-osoitetta ei sallita. Aliverkkotunnusten on oltava muodossa https://www.domain.tld tai https://domain.tld ilman alihakemistoa."
      },
      "account": {
        "title": "Tili",
        "description": "Valitse tili, jolle tämä verkkotunnus liitetään",
        "placeholder": "Valitse tili...",
        "feedback": "Sinun on valittava tili"
      },
      "platform": {
        "title": "Alusta",
        "description": "Valitse verkkosivusi alusta CMS-nimen mukaan.",
        "learn": "Opi valitsemaan se",
        "placeholder": "Etsi alustaa CMS-nimellä...",
        "info": {
          "title": "⚠ Tämä alusta on lisätty äskettäin.\n",
          "desc": "Tämä verkkosivujen rakentaja-alusta on tuettu Linguisen toimesta, vaikka se on lisätty äskettäin. Jos koet ongelmia, ota meihin yhteyttä suoraan sähköpostilla:"
        },
        "description_read_only": "Verkkosivusi käyttämä alusta",
        "feedback": "Sinun on valittava alusta"
      },
      "language": {
        "title": "Kieli",
        "description": "Valitse sivustosi peruskieli",
        "placeholder": "Valitse kieli...",
        "feedback": "Sinun on valittava kieli",
        "description_read_only": "Verkkosivusi peruskieli"
      },
      "token": {
        "title": "API-avain",
        "description": "Tämä on API-avain, joka kopioidaan verkkosivullesi",
        "copy": "Kopioi leikepöydälle",
        "reset": "Nollaa API-avain",
        "reset_confirm": "Vahvista API-avaimen nollaus"
      },
      "languages": {
        "title": "Käännöskielet",
        "description": "Valitse kielet, joille haluat verkkosivustosi olevan käännettävissä",
        "placeholder": "Valitse kieliä...",
        "feedback": "Sinun on valittava vähintään yksi kieli"
      },
      "defaultRules": {
        "title": "Oletussäännöt",
        "description": "Olemme määrittäneet joukon käytettäviä sääntöjä parantaaksemme käännöksiä ja estääksemme ei-toivotun sisällön, kuten WordPress-hallintapaneelin, kääntämisen.\nVoit myöhemmin poistaa tai muokata näitä sääntöjä tarvittaessa."
      },
      "disallow_deletion": "Et voi poistaa verkkotunnusta, jolla on voimassa oleva tilaus",
      "delete_confirm": "Vahvista verkkotunnuksen poistaminen",
      "delete": "Poista verkkotunnus",
      "dynamic": {
        "title": "Käännä dynaaminen sisältö",
        "description": "JavaScriptin ja AJAX-pyyntöjen luoma dynaaminen sisältö käännetään (tämä vaihtoehto lisää käännöskäyttöä)"
      },
      "partial_translations": {
        "title": "Salli osittainen käännös",
        "description": "Jos tilisi on saavuttanut käännösrajan, mutta sivu vaatii silti käännöstä, Linguise voi jatkaa sivun näyttämistä jo käännetyn sisällön osalta.\nOsa sivusta jää kuitenkin kääntymättömäksi, kunnes päivität kiintiötä.\n\nVaikka pieni määrä kääntymätöntä sisältöä ei yleensä haittaa SEO:a, liian suuri määrä voi vaikuttaa negatiivisesti käyttökokemukseen.\nVoit asettaa rajan kääntymättömän sisällön prosenttiosuudelle sivulla. Jos raja ylittyy, käyttäjät ohjataan automaattisesti alkuperäiskieliseen versioon.",
        "never": "Ei koskaan"
      },
      "translate_error_pages": {
        "title": "Käännä virhesivut",
        "description": "Linguise voi kääntää kaikki virhesivut, mutta jos virhesivulla on dynaamista sisältöä, kuten IP-osoite tai pyynnön tunniste, sinun tulisi välttää näiden sivujen kääntämistä.",
        "not_found_page": {
          "title": "Käännä 404-sivu"
        },
        "error_page": {
          "title": "Käännä muut virhesivut"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Aiempi verkkotunnus löytyi",
          "description": "Käyttäjälle löytyi aiempi verkkotunnus, haluatko käyttää sitä?"
        }
      },
      "search_tl": {
        "title": "Hae käännöksiä",
        "description": "Ota käyttöön käännösten haku verkkosivualustallesi (Kokeellinen, tämä lisää käännöskäyttöä)"
      },
      "shopify_promo": {
        "info": "Hyviä uutisia! Meillä on nyt Shopify-natiivisovellus, jonka voit asentaa Shopify App Store",
        "hyperlink": "Klikkaa tästä ja asenna Linguise sovelluksesta.",
        "next_btn": "Siirry Shopify-kauppaan asentaaksesi sovelluksen",
        "info_legacy": "Hyviä uutisia! Meillä on nyt Shopify-natiivisovellus, jonka voit asentaa Shopify App Store",
        "description_legacy": "Valitse Shopify-alusta Shopify Legacyn sijaan"
      },
      "wix_promo": {
        "info": "Hyviä uutisia! Meillä on nyt Wix-natiivisovellus, jonka voit asentaa Wix App Marketista.",
        "hyperlink": "Klikkaa tästä ja asenna Linguise sovelluksesta.",
        "next_btn": "Siirry Wix App Markettiin asentaaksesi sovelluksen",
        "info_legacy": "Hyviä uutisia! Meillä on nyt Wix-natiivisovellus, jonka voit asentaa Wix App Marketista.",
        "description_legacy": "Valitse Wix-alusta Wix Legacyn sijaan"
      },
      "ai_disallow_deletion": "Et voi poistaa tätä verkkotunnusta, kun tekoälykiintiö on vielä käytettävissä.\n\nOta yhteyttä tukitiimiimme, jos haluat poistaa tämän verkkotunnuksen osoitteessa",
      "language_removal": {
        "card": {
          "title": "Poista poistettujen kielten käännökset",
          "description": "Nämä kielet poistettiin verkkosivustoltasi, mutta niiden tallennetut käännökset lasketaan yhä kiintiöösi. Poista ne saadaksesi sanat takaisin.",
          "button": "Poista käännökset"
        },
        "hint": "Niihin käytetyt sanat palautetaan kiintiöösi. Voit tehdä tämän kullekin sivustolle kerran {{days}} päivän välein.",
        "modal": {
          "title": "Poistetaanko käännökset?",
          "intro": "Nämä käännökset poistetaan pysyvästi:",
          "warning": "Tätä ei voi kumota. Käytetyt sanat palautetaan kiintiöösi, mikä voi kestää muutaman minuutin.",
          "limit": "Voit tehdä tämän kullekin sivustolle kerran {{days}} päivän välein.",
          "confirm": "Poista käännökset"
        },
        "scheduled": "Käännöksiä poistetaan ja kiintiösi päivitetään pian.",
        "cooldown": "Tämän sivuston käännökset poistettiin äskettäin. Voit poistaa ne uudelleen {{date}}.",
        "latest_completed": {
          "title": "Viimeisin valmis poisto",
          "description": "Tarkista poistetut kielet ja kiintiöösi palautetut sanat.",
          "languages": "Poistetut kielet",
          "words_returned": "Kiintiöösi palautetut sanat: {{words}}",
          "completed_at": "Valmistui {{date}}"
        },
        "status": {
          "recent_title": "Viimeisin käännösten poisto",
          "recent_description": "Seuraa viimeisintä poistoa ja katso, milloin voit tehdä seuraavan.",
          "progress_title": "Poiston edistyminen",
          "loading": "Tarkistetaan poiston edistymistä...",
          "unavailable": "Poiston edistymistä ei voitu ladata. Päivitä sivu ja yritä uudelleen.",
          "label": "Tila",
          "pending": "Jonossa",
          "processing": "Käynnissä",
          "completed": "Valmis",
          "failed": "Epäonnistui",
          "unknown": "Tila ei ole saatavilla",
          "percent": "{{percent}} % valmis",
          "current_stage": "Nykyinen vaihe: {{stage}}",
          "processed": "{{processed}} tietuetta käsitelty",
          "processed_total": "{{processed}} / {{total}} tietuetta käsitelty",
          "requested_at": "Pyydetty {{date}}",
          "started_at": "Aloitettu {{date}}",
          "completed_at": "Valmistui {{date}}",
          "cooldown_period": "Voit tehdä tämän kullekin sivustolle kerran {{days}} päivän välein.",
          "cooldown_blocked": "Uutta poistoa ei voi vielä aloittaa.",
          "stage": {
            "queued": "Odottaa aloitusta",
            "processing": "Käynnissä",
            "refund_summary": "Lasketaan palautettavia sanoja",
            "search_translations": "Poistetaan hakukäännöksiä",
            "url_translations": "Poistetaan URL-käännöksiä",
            "translations": "Poistetaan käännöksiä",
            "completed": "Valmis",
            "failed": "Epäonnistui",
            "unknown": "Käynnissä"
          }
        },
        "forbidden": "Sinulla ei ole oikeutta poistaa käännöksiä."
      }
    },
    "main": {
      "edit": "Muokkaa verkkotunnusta",
      "add": "Lisää verkkotunnus",
      "wizard": "Tervetuloa! Uuden verkkotunnuksen luonnin ohjattu toiminto",
      "common": "Verkkotunnus"
    },
    "notice": {
      "broken_card": "Emme voineet uusia tilaustasi kohteelle {{url}} nykyisellä maksutavalla, päivitä maksukorttisi",
      "quota_reached": "Käännöskiintösi kohteelle {{url}} on täynnä, päivitä jatkaaksesi verkkosivustosi käännöstä",
      "ai_no_subscription": "Käännös AI:lle kohteelle {{url}} edellyttää aktiivista tilausta tai aktiivista kokeilua. Se pysähtyy ilman tilausta, päivitä jatkaaksesi",
      "important": "Tärkeä",
      "quota_reached_button": "Päivitä suunnitelmasi nyt",
      "broken_card_button": "Päivitä maksukorttisi",
      "ai_no_subscription_button": "Päivitä suunnitelmasi nyt",
      "quota_warning": "Käännöskiintiösi osoitteelle {{url}} on saavuttanut {{throttling_used_percent}}%, tämä nollautuu {{ttl}} kuluttua",
      "locked": "Verkkotunnus {{url}} on tällä hetkellä lukittu siirtoa varten. Voit silti käyttää sivustoasi, mutta et voi muokata tai lisätä uusia käännöksiä!"
    },
    "subdomains": {
      "config_ok": "Aliverkkotunnusten DNS on määritetty oikein.",
      "config_invalid": "Aliverkkotunnusten DNS tarvitsee lisäasetuksia toimiakseen.",
      "config_check": "Aliverkkotunnusten DNS-asetuksia tarkistetaan, odota hetki...",
      "entri_timeout": "Entri ilmoitti, että aliverkkotunnusten DNS-levitysprosessi on aikakatkaistu – sinun on yritettävä uudelleen tai tehtävä se manuaalisesti.",
      "entri_process": "DNS on lisätty Entrillä ja levitykseen kuluu yleensä 10–30 minuuttia (kaikki kielialiverkkotunnukset kuten fi.domain.com). Jos DNS-validointi ei valmistu 24 tunnissa, ota yhteyttä tukeemme: support@linguise.com",
      "entri_ok": "DNS-levitys on käynnissä! Odotetaan levitystä...",
      "infos": "Sinun on lisättävä nämä DNS-merkinnät DNS-verkkotunnustietueisiisi aktivoidaksesi käännöksen. Napsauta tarkistuspainiketta, kun se on tehty. DNS-tietueiden levittäminen voi kestää jonkin aikaa, joten sinun on ehkä palattava muutaman minuutin tai tunnin kuluttua.",
      "check": "Tarkista DNS-kokoonpano"
    },
    "subscription": {
      "next_payment_amount": "Tulevat maksut",
      "next_payment_date": "Seuraavan maksun päivämäärä",
      "invoice": {
        "header": "Laskuhistoria",
        "date": "Päivämäärä",
        "amount_due": "Summa",
        "status": "Tila",
        "actions": "Toiminnot",
        "description": "Kun tapahtumia on saatavilla, näet ne tässä.",
        "status_text": {
          "draft": "Luonnos",
          "failed": "Epäonnistunut",
          "open": "Odottaa",
          "paid": "Maksettu",
          "retrying": "Yritetään uudelleen",
          "uncollectible": "Perimätön",
          "void": "Mitätön"
        },
        "view": "Näytä",
        "empty": "Tälle tilaukselle ei löytynyt laskuja",
        "retry_payment": "Yritä uudelleen"
      },
      "next_cancellation": "Irtisanomispäivä",
      "cancel": "Peruuta tilaus",
      "change_plan": "Vaihda suunnitelmaa",
      "change": "Vaihda",
      "suspend": "Keskeytä maksu",
      "resume": "Palauta tilaus",
      "back": "Takaisin",
      "save": "Tallenna",
      "confirm_resume": "Haluatko varmasti palauttaa tämän tilauksen?",
      "confirm_cancel": "Haluatko varmasti peruuttaa tämän tilauksen?",
      "confirm_header": "Oletko varma?",
      "missing_status": "Tämä tilaus puuttuu",
      "not_found": "Tälle verkkotunnukselle ei löytynyt tilausta",
      "confirm_manual_retry": "Haluatko varmasti yrittää maksua uudelleen?",
      "no_payment_method": "Tuntematon",
      "remove_billing": "Poista",
      "shopify_maneged": "Tämän tilauksen hallinnasta vastaa Shopify. Hallitse sitä Shopify-hallintapaneelissasi.",
      "unknown_plan": "Tuntematon suunnitelma"
    }
  },
  "domain_listing": {
    "add": "Lisää verkkosivusto",
    "select": "Valitse verkkotunnus"
  },
  "editable": {
    "number": "numero {{id}}"
  },
  "footer": {
    "about": "Tietoa",
    "support": "Tuki"
  },
  "frontendEditor": {
    "main": "Live-editori",
    "description": "Live-editorin avulla voit muokata käännöksiä suoraan verkkosivustollasi.",
    "button": "Avaa Live-editori",
    "language_selection": "Käännöskielen valinta",
    "video_label": "Opi käyttämään live-editoria"
  },
  "general": {
    "403": {
      "tab_title": "Hups – 403-virhe",
      "title": "Pääsy evätty",
      "message": "Sinulla ei näyttäisi olevan pääsyä pyydetylle sivulle.",
      "home": "Paluu etusivulle"
    },
    "404": {
      "tab_title": "Hups – 404-virhe",
      "title": "Sivua ei löydy",
      "message": "Vaikuttaa siltä, että olet eksynyt. Älä huoli... sitä sattuu parhaimmillekin. Tässä vinkki, joka voi auttaa takaisin raiteille.",
      "home": "Paluu etusivulle"
    },
    "500": {
      "tab_title": "500-virhe",
      "title": "Sisäinen palvelinvirhe",
      "message": "Voit yrittää päivittää sivun tai ottaa meihin yhteyttä",
      "home": "Paluu etusivulle"
    },
    "fields": {
      "alert": "Jotkin kentät eivät ole kelvollisia, korjaa virheelliset kentät.",
      "invalid": "Tämä kenttä ei ole kelvollinen",
      "phone_re": "Puhelinnumero ei ole kelvollinen",
      "phone_invalid": "Puhelinnumero ei ole kelvollinen",
      "email": "Sähköpostiosoitekenttä on virheellinen"
    },
    "table": {
      "no_data": "Täällä ei ole vielä tietoja..."
    },
    "saving": "Tallennetaan...",
    "save": "Tallenna",
    "save_and_quit": "Tallenna ja poistu",
    "invite": "Kutsu",
    "cancel": "Peruuta",
    "yes": "Kyllä",
    "no": "Ei",
    "nextStep": "Seuraava vaihe",
    "loading": "Odota hetki, sovellus latautuu",
    "goback": "Palaa takaisin",
    "manage": "Hallinnoi",
    "delete": "Poista",
    "deleting": "Poistetaan...",
    "confirm": "Vahvista",
    "unknown": "Tuntematon",
    "hide": "Piilottaa",
    "show": "Näytä",
    "on": "Päällä",
    "off": "Pois",
    "default": "Oletus"
  },
  "home": {
    "header": "Koti",
    "manage": "Hallinnoi tilausta",
    "canceled": "Ajastettu peruutettavaksi",
    "activate_now": "Aktivoi nyt",
    "activate_plan_now": "Tilaa nyt",
    "upgrade_plan_now": "Päivitä suunnitelma nyt",
    "trial_message_part_1": "Olet tällä hetkellä kokeilujaksolla, ",
    "trial_message_part_2": "voit aktivoida tilauksen milloin tahansa.",
    "add": "Lisää verkkotunnus",
    "table": {
      "title": "Verkkotunnukset",
      "description": "Luettelo verkkotunnuksistasi, klikkaa verkkotunnusta hallitaksesi käännöksiä"
    },
    "domains": {
      "empty": "Tällä tilillä ei ole verkkotunnuksia"
    },
    "accountsList": {
      "title": "Tilit",
      "add": "Lisää uusi tili",
      "name": "Tilin nimi"
    },
    "update_credit_card": "Päivitä luottokortin tiedot",
    "cancelling_subs": "Perutaan {{0}}",
    "resume_subscription": "Jatka tilausta",
    "shopify_managed": "Shopify hallitsee",
    "trial_ends_at": "Päättyy {{0}}",
    "free_trial": "Ilmainen kokeilu",
    "no_subs": "Ei aktiivista tilausta"
  },
  "invoices": {
    "title": "Laskut",
    "list": {
      "title": "Laskuluettelo"
    },
    "table": {
      "customer": "Asiakas",
      "domain": "Verkkotunnus",
      "amountPaid": "Maksettu summa",
      "status": "Tila",
      "date": "Päivämäärä",
      "invoice": "Lasku",
      "pay": "Maksa lasku",
      "actions": "Toiminnot",
      "deleted_domain": "Verkkotunnus poistettu",
      "plan_name": "Paketti",
      "action": "Toiminto"
    },
    "listPending": {
      "title": "Odottavien laskujen luettelo"
    }
  },
  "language_settings": {
    "display": "Kieliluettelon näyttö",
    "position": "Sijainti",
    "display_help_text": "Näytä lippu ja/tai kielen nimet. Kielen vaihtajan oletussijainti voi olla missä tahansa sisällössä tai kiinteässä sijainnissa, joka pysyy paikallaan tai liikkuu vieritettäessä",
    "side_by_side": "Rinnakkain",
    "dropdown": "Pudotusvalikko",
    "popup": "Ponnahdusikkuna",
    "flag": "Lippu",
    "lang_name": "Kielen nimi",
    "lang_short_name": "Lyhyet nimet",
    "positions": {
      "in_place": "Paikallaan",
      "top_left": "Ylhäällä vasemmalla",
      "top_left_no_scroll": "Ylhäällä vasemmalla (ei vieritystä)",
      "top_right": "Ylhäällä oikealla",
      "top_right_no_scroll": "Ylhäällä oikealla (ei vieritystä)",
      "bottom_left": "Alhaalla vasemmalla",
      "bottom_left_no_scroll": "Alhaalla vasemmalla (ei vieritystä)",
      "bottom_right": "Alhaalla oikealla",
      "bottom_right_no_scroll": "Alhaalla oikealla (ei vieritystä)"
    },
    "lang_names_display": {
      "title": "Kielten nimien näyttö",
      "help_text": "Näytä kielten nimet kielenvaihtajassa joko englanniksi tai alkuperäisellä kielellä, esim. Ranska tai Français",
      "english": "Englanti",
      "native_languages": "Alkuperäiset kielet"
    },
    "flag_shape": {
      "title": "Lipun tyyli",
      "help_text": "Käytä pyöreitä tai suorakaiteisia svg-lippukuvakkeita",
      "round": "Pyöreä",
      "rectangular": "Suorakaide"
    },
    "english_flag_type": {
      "title": "Englannin lipun tyyppi",
      "help_text": "Käytä Iso-Britannian tai USA:n lippua englanniksi",
      "usa": "USA:n lippu",
      "great_britain": "Iso-Britannian lippu"
    },
    "german_flag_type": {
      "title": "Saksan lipun tyyppi",
      "help_text": "Käytä Itävallan tai Saksan lippua saksaksi",
      "german": "Saksan lippu",
      "austria": "Itävallan lippu"
    },
    "spain_flag_type": {
      "title": "Espanjan lipun tyyppi",
      "help_text": "Käytä Meksikon tai Espanjan lippua espanjaksi",
      "spanish": "Espanjan lippu",
      "mexico": "Meksikon lippu",
      "peruvian": "Perun lippu"
    },
    "portugal_flag_type": {
      "title": "Portugalin lipun tyyppi",
      "help_text": "Käytä Portugalin tai Brasilian lippua portugalin kieleksi",
      "portugal": "Portugalin lippu",
      "brazil": "Brasilian lippu"
    },
    "taiwanese_flag_type": {
      "title": "Taiwanin lipun tyyppi",
      "help_text": "Käytä Taiwanin tai Kiinan lippua taiwaniksi",
      "taiwanese": "Taiwanin lippu",
      "chinese": "Kiinan lippu"
    },
    "flag_border_radius": {
      "title": "Lipun reunan pyöristys (px)",
      "help_text": "Jos käytät suorakaiteen muotoista lippua, voit asettaa yksilöllisen reunan pyöristyksen pikseleinä"
    },
    "flag_width": {
      "title": "Lipun koko (px)",
      "help_text": "Valitse lippujen koko pikseleinä. Tämä ei muuta kuvan painoa, koska se on svg-muodossa"
    },
    "lang_color": {
      "color_title": "Kielen nimen väri",
      "color_help_text": "Valitse oletustekstin väri kielen nimille",
      "hover_color_title": "Kielen nimen hover-väri",
      "hover_color_help_text": "Valitse hiiren osoittimen hover-tekstin väri kielen nimille",
      "color_popup_title": "Ponnahdusikkunan kielen väri",
      "color_popup_help_text": "Ponnahdus- tai pudotusalueen kielen otsikon väri",
      "hover_color_popup_title": "Ponnahdusikkunan kielen hover-väri",
      "hover_color_popup_help_text": "Valitse hiiren osoittimen hover-tekstin väri ponnahdus- tai pudotusalueen kielen otsikolle"
    },
    "flag_box_shadow": {
      "shadow_title": "Lipun laatikon varjo",
      "shadow_help_text": "Väri ja varjon koko kielilipuille",
      "hover_shadow_title": "Lipun laatikon varjo hoverissa",
      "hover_shadow_help_text": "Väri ja varjon koko kielilipuille hiiren hoverissa",
      "shadow_h_offset": "Varjon H-siirtymä (px)",
      "shadow_v_offset": "Varjon V-siirtymä (px)",
      "shadow_blur": "Varjon sumennus (px)",
      "shadow_spread": "Varjon leviäminen (px)",
      "shadow_color": "Varjon väri"
    },
    "order": "Kielten järjestys",
    "language_order_help": "Kielten järjestys, joka näytetään kielenvaihtajassa. Voit vetää ja pudottaa kielen uudelleenjärjestääksesi.",
    "order_reset": "Palauta järjestys",
    "language_order_dragdrop": "Voit vetää ja pudottaa kielen uudelleenjärjestääksesi.",
    "popup_lang_name": "Ponnahdusikkunan kielen nimi",
    "preview": "Kielen esikatselu"
  },
  "link": {
    "form": {
      "original": {
        "title": "Alkuperäinen lähde",
        "description": "Lisää alkuperäinen linkin URL ja korvaa se kielikohtaisesti alla",
        "srcset_description": "Muokkaat kuvan URL-osoitetta. Lue dokumentaatio erityisesti jos käytät srcset:iä tai et tiedä mitä se on",
        "link": "Linkki",
        "match_link": "Täsmäämismoodi",
        "match_exact": "Tarkka",
        "match_wildcard": "Jokerimerkki",
        "match_regex": "Säännöllinen lauseke"
      },
      "alternative_languages": {
        "title": "Korvattavat linkit",
        "description": "Korvaa medialinkit ja ulkoiset linkit kielittäin kaikilla sivuillasi…",
        "link": "Korvattava linkki"
      },
      "error": {
        "atLeastOne": "Lisää vähintään yksi käännös.",
        "url": "URL on virheellinen",
        "extension": "Linkissä on oltava tiedostopääte, mutta se ei voi olla .html tai .php. Lisäksi linkissä ei saa olla kieliopolkuja, esim. \"/fr\"",
        "regex": "Säännöllinen lauseke on virheellinen",
        "wildcard": "Jokerilinkillä on virheellinen protokolla"
      }
    },
    "main": {
      "parent": "Linkit",
      "edit": "Muokkaa linkkiä"
    }
  },
  "links": {
    "title": "Media- ja ulkoisten linkkien hallinta",
    "description": "Listaa ja muokkaa verkkosivustosi medialinkkejä tai ulkoisia linkkejä.",
    "add": "Lisää linkki",
    "delete": "Poista linkki",
    "table": {
      "original": "Alkuperäinen",
      "language": "Kieli",
      "translation": "Käännös",
      "action": "Toiminto",
      "delete_confirm": "Vahvista linkin poisto"
    }
  },
  "members": {
    "header": "Jäsenet",
    "invite": "Kutsu uusi jäsen",
    "modal": {
      "inviteHeader": "Kutsu uusi jäsen",
      "editHeader": "Muokkaa jäsentä",
      "detachHeader": "Irrota jäsen",
      "detachBody": "Haluatko varmasti irrottaa jäsenen tältä tililtä?",
      "selfDetachBody": "Haluatko varmasti irrottaa itsesi tämän tilin hallinnasta? Tämän jälkeen et voi enää käyttää tämän tilin tietoja."
    },
    "table": {
      "title": "Jäsenluettelo",
      "description": "Jäsenten roolit ja verkkotunnusten käyttöoikeudet",
      "name": "Nimi",
      "email": "Sähköposti",
      "websites": "Verkkosivustot",
      "languages": "Kielet",
      "role": "Rooli",
      "status": "Tila",
      "resendInvite": "lähetä uudelleen",
      "inviteSent": "kutsu lähetetty",
      "actions": "Toiminnot",
      "edit": "Muokkaa",
      "detach": "Irrota",
      "empty": "Sinulla ei ole vielä jäseniä",
      "all_website": "Kaikki verkkosivustot ja kielet",
      "roles": {
        "admin": "Ylläpitäjä",
        "manager": "Ylläpitäjä",
        "translator": "Kääntäjä"
      },
      "statuses": {
        "pending": "Odottaa",
        "accepted": "Hyväksytty",
        "declined": "Hylätty"
      }
    },
    "errors": {
      "role": "Sinun on valittava rooli",
      "domains": "Valitun roolin on käytettävä vähintään yhtä verkkosivustoa",
      "languages": "Valituilta verkkosivustoilta on valittava vähintään yksi kieli"
    },
    "inviteSent": "Kutsu on lähetetty onnistuneesti"
  },
  "pagination": {
    "showing": "Näytetään {{limit}} / {{total}} tuloksesta",
    "showing_only_count": "Näytetään {{limit}} tulosta"
  },
  "payments_method": {
    "header": "Maksutavat",
    "table": {
      "title": "Maksutapaluettelo",
      "description": "Tilillesi liitetyt maksutavat",
      "default": "Oletus",
      "action_edit_remove": "Muokkaa tai poista",
      "action_remove": "Poista",
      "action_default": "Aseta oletukseksi",
      "action_fallback": "Aseta varaksi",
      "expires": "Vanhenee",
      "add_new_card": "Lisää maksutapa",
      "action_fallback_remove": "Poista varalta",
      "fallback": "Varamaksutapa",
      "action_edit": "Muokkaa",
      "action_delete": "Poista",
      "action_default_remove": "Poista oletuksena",
      "domain_count@@one": "Käytössä {{count}} verkkotunnuksella",
      "domain_count@@other": "Käytössä {{count}} verkkotunnuksessa"
    },
    "paypal_bind": {
      "button": "Yhdistä PayPal-tili",
      "button_load": "Yhdistetään...",
      "disconnected": "Ei yhdistetty",
      "success": "PayPal-tilisi on nyt yhdistetty, 5 $ vähennetään seuraavasta laskustasi!",
      "success_no_promo": "PayPal-tilisi on nyt yhdistetty",
      "error": "Tapahtui virhe",
      "success_header": "Onnistui"
    },
    "card_add": {
      "header": "Lisää uusi kortti",
      "success": "Uusi kortti yhdistetty Linguiseen!",
      "terms": "Antamalla korttitiedot sallit Linguisen veloittaa korttiasi tulevista maksuista palveluehtojemme mukaisesti."
    },
    "card_detail": {
      "header": "Kortin tiedot",
      "delete": {
        "error": "Et voi poistaa tätä maksutapaa, koska siihen liittyy aktiivisia tilauksia!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Tämän maksutavan tilaukset",
        "header_domain": "Verkkotunnus",
        "header_plan": "Paketti",
        "header_status": "Tila",
        "header_actions": "Toiminnot",
        "cancelling": "Perutaan: {{0}}",
        "next_payment": "Seuraava maksu: {{0}}",
        "action_renew": "Uusi",
        "no_subs_header": "Ei näytettäviä tilauksia",
        "no_subs_desc": "Kun tilauksia luodaan tälle kortille, kaikki tiedot näytetään tässä",
        "action_manage": "Hallitse"
      },
      "status": {
        "active": "Aktiivinen",
        "canceled": "Peruutettu",
        "incomplete": "Maksamaton",
        "incomplete_expired": "Maksamaton (vanhentunut)",
        "missing": "Virhe",
        "past_due": "Myöhässä",
        "trialing": "Kokeilu",
        "unpaid": "Maksamaton"
      }
    },
    "delete_confirm_body": "Haluatko varmasti poistaa tämän maksutavan? Toimintoa ei voi perua!",
    "delete_confirm_header": "Poista maksutapa?",
    "card_edit": {
      "header": "Muokkaa korttia",
      "billing_header": "Laskutustiedot",
      "address_error": "Osoite on pakollinen!",
      "card_number": "Kortin numero",
      "card_expiry": "Viimeinen käyttöpäivä",
      "expiry_error_month": "Virheellinen kuukausi annettu",
      "expiry_error_year": "Virheellinen vuosi annettu",
      "expiry_error_expired": "Korttisi vanhenemisvuosi on jo mennyt.",
      "card_header": "Kortin tiedot",
      "expiry_error_empty": "Tämä kenttä on pakollinen!"
    }
  },
  "plans": {
    "per": "per",
    "wordsTranslated": "käännetyt sanat",
    "current": "Nykyinen",
    "archived": "Arkistoitu",
    "day": "päivä",
    "week": "viikko",
    "month": "kuukausi",
    "year": "vuosi",
    "activate": "Aktivoi",
    "cancel": "Peruuta",
    "change": "Vaihda",
    "upgrade": "Päivitä",
    "downgrade": "Laske tasoa",
    "resume": "Jatka",
    "notEnoughWords": "Ei tarpeeksi sanoja",
    "yearIntervalOnly": "Vuosisuunnitelmasta ei voi vaihtaa",
    "subsCanceled": "Toinen tilauksen peruminen on käynnissä",
    "wordsUnlimited": "Rajattomasti sanoja",
    "tabs": {
      "day": "Päivähinnat",
      "week": "Viikkohinnat",
      "month": "Kuukausihinnat",
      "year": "Vuosihinnat",
      "sub_texts": {
        "day": "Yksi kiinteä hinta joka päivä",
        "week": "Yksi kiinteä hinta joka viikko",
        "month": "Yksi kiinteä hinta joka kuukausi",
        "year": "Yksi kuukausi ilmaiseksi, yksi lasku vuodessa"
      }
    },
    "details": {
      "new_languages": "Lisää uusia kieliä milloin tahansa",
      "one_month_trial": "Yhden kuukauden ilmainen kokeilu jokaiselle uudelle verkkosivustolle",
      "multi_content_indexed": "100 % monikielisestä sisällöstä indeksoitu",
      "translate_new_content": "Käännä uusi sisältö välittömästi",
      "free_installation": "Ilmainen asennus ja määritys",
      "compared_monthly_plan": "Yksi kuukausi ilmaiseksi kuukausisuunnitelmiin verrattuna",
      "risk_free_recurring": "Riskitön toistuva maksuvirhe",
      "unlimited_languages": "Rajattomasti kieliä ja sivunäyttöjä",
      "high_server_resources": "Korkeat palvelinresurssit",
      "billed": {
        "day": "Laskutetaan päivittäin",
        "week": "Laskutetaan viikoittain",
        "month": "Laskutetaan kuukausittain",
        "year": "Laskutetaan vuosittain"
      },
      "request_max_size": "{{0}} pyynnön enimmäiskoko"
    },
    "frequent_question": {
      "title": "Usein kysytyt kysymykset",
      "questions": {
        "trial": {
          "question": "Voinko käyttää kokeilua uudella verkkosivuston verkkotunnuksella?",
          "answer": "Kyllä, tarjoamme 30 päivän ilmaisen kokeilun jokaiselle uudelle verkkotunnukselle, jonka lisäät tilillesi. Näin voit testata käännöspalvelua täysin uudella verkkosivustollasi."
        },
        "seo": {
          "question": "Kuinka kauan SEO-ni parantuminen vie?",
          "answer": "Sisällön ja monikielisen sisällön indeksoiminen ja hyvä sijoittuminen vie aikaa. Verkkosivustosi liikenteestä ja koosta riippuen se vie 3–6 viikkoa."
        },
        "quota": {
          "question": "Sisältyvätkö ihmiskäännökset kiintiöön?",
          "answer": "Ei, sanamääräraja koskee vain automaattisia konekäännöksiä. Kääntäjä voi muokata automaattisia käännöksiä manuaalisesti ilman rajoituksia."
        }
      }
    },
    "best_offer": "Paras tarjous",
    "period": {
      "days@@one": "päivä",
      "days@@other": "{{count}} päivää",
      "hours@@one": "tunti",
      "hours@@other": "{{count}} tuntia",
      "minutes@@one": "minuutti",
      "minutes@@other": "{{count}} minuuttia",
      "seconds@@one": "sekunti",
      "seconds@@other": "{{count}} sekuntia"
    },
    "words": {
      "billion": "{{value}}B",
      "million": "{{value}}M",
      "thousand": "{{value}}K"
    },
    "throttling_info": "{{words}} sanaa per {{period}}"
  },
  "profile": {
    "welcome": "Tervetuloa!",
    "account": "Oma tili",
    "subscriptions": "Tilaukset",
    "logout": "Kirjaudu ulos"
  },
  "register": {
    "errors": {
      "password": "Vähintään 8 merkkiä, mikä tahansa merkki"
    }
  },
  "route": {
    "dashboard": "Koontinäyttö",
    "rules": "Säännöt",
    "translations": "Käännökset",
    "search_translations": "Hakulausekkeet",
    "urls_translations": "URL-käännökset",
    "links": "Media ja ulkoiset linkit",
    "online_editor": "Suora editori",
    "settings": "Asetukset",
    "domain": {
      "finish": "Asetukset",
      "preconfig": "Asetukset"
    },
    "home": "Koti",
    "domain_list": "Verkkotunnusluettelo",
    "members": "Jäsenet",
    "invoices": "Laskut",
    "billing": "Laskutustiedot",
    "language_display": "Kieliliput näyttö",
    "payment_methods": "Maksutavat",
    "ai_translation": "Tekoälykäännös",
    "ai_translation_settings": "Asetukset",
    "ai_translation_pricing": "Hinnoittelu"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Ohitettava teksti",
        "add": "Lisää uusi",
        "title": "Ohitettava teksti",
        "description": "Lisää yksi tai useampi ohitettava teksti",
        "ignore_case": "Ohita kirjainkoko"
      },
      "html_content": {
        "title": "Käytä HTML-sisältöön",
        "description": "Käytä sääntöä koko sisällössä tai valitsemalla tietty CSS-valitsin",
        "all_page": "Koko sivu",
        "css_selector": "CSS-valitsin",
        "label": "CSS-valitsin",
        "placeholder": "Valitsin jota käytetään",
        "add": "Lisää uusi"
      },
      "apply_to_urls": {
        "title": "Kohdistu URL-osoitteisiin",
        "description": "Valitse tietyt URL-osoitteet, joissa haluat säännön olevan voimassa",
        "all_urls": "Kaikki URL-osoitteet",
        "selected_urls": "Valitut URL-osoitteet",
        "label": "URL, johon kohdistetaan",
        "placeholder": "URL, johon kohdistetaan",
        "original_url": "Alkuperäiset URL-osoitteet",
        "translated_url": "Käännetty URL-osoite",
        "wildcard": "Jokerimerkki",
        "regex": "Säännöllinen lauseke",
        "add": "Lisää uusi",
        "expression": "Lausekkeen tyyppi"
      },
      "apply_urls": {
        "title_exclude": "Poissulje URL-osoitteissa",
        "title_replace": "Korvaa URL-osoitteissa",
        "title_description": "Käytä tätä sääntöä myös URL-osoitteiden käännöksissä"
      },
      "apply_languages": {
        "title": "Kohdistu kieliin",
        "description": "Valitse tietyt kielet, joissa haluat säännön olevan voimassa",
        "all_languages": "Kaikki kielet",
        "selected_languages": "Valitut kielet",
        "placeholder": "Valitse kielet...",
        "feedback": "Sinun on valittava kieli"
      },
      "name": {
        "title": "Otsikko",
        "description": "Anna säännölle kuvaava nimi käytännöllisyytesi vuoksi",
        "placeholder": "Säännön nimi"
      },
      "type": {
        "title": "Tyyppi",
        "description": "Valitse lisättävän säännön tyyppi",
        "text_ignore": "Tekstin ohitus",
        "text_replace": "Tekstin korvaus",
        "content_exclusion": "Sisällön poissulkeminen",
        "url_exclusion": "URL-osoitteen perusteinen poissulkeminen",
        "ignore_inline": "Ohita sisäinen",
        "full_description": {
          "text_ignore": "Lisää sääntöjä estääksesi tietyt tekstit kääntymästä. Kyseessä voi olla tuotteen nimi, tuotemerkki tai muu tekninen elementti, jota et halua käännettäväksi.",
          "text_replace": "Tekstin korvaus mahdollistaa haluamasi käännöksen. Tilanne voi olla tarpeen, kun käännös ei huomioi kontekstia.",
          "content_exclusion": "Sisällön poissulkeminen auttaa estämään tietyt sivun osat kääntymästä.\nJos haluat kokonaan jättää sivun kääntämättä (ei monikielistä URL-osoitetta eikä käännettyä sisältöä), käytä tyyppiä \"URL-osoitteen perusteinen poissulkeminen\"",
          "url_exclusion": "Sivun käännöksen poissulkeminen auttaa määrittämään sivut, joita et halua käännettäväksi.",
          "ignore_inline": "Estä tietyt sisällöt kääntymästä sisäisenä sisältönä, vaan käännä jokainen tagi erikseen."
        }
      },
      "text_replace": {
        "title": "Korvattava teksti",
        "description": "Korvaa tietyt tekstit haluamallasi käännöksellä. Korvaa mitä tahansa tekstiä kaikilla sivuilla kielikohtaisesti…",
        "text_to_replace": "Korvattava teksti",
        "ignore_case": "Ohita kirjaintarkkuus",
        "text_type": "Korvaus käännettävässä",
        "text_type_original": "Alkuperäinen",
        "text_type_translation": "Käännös",
        "keep_case": "Yritä säilyttää kirjaintyyppi",
        "add": "Lisää uusi"
      },
      "content_exclusion": {
        "title": "Sisällön poissulkeminen",
        "description": "Valitse yksi tai useampi CSS-valitsin, joita ei käännetä",
        "label": "CSS-valitsin",
        "placeholder": "Valitsin, johon kohdistetaan",
        "add": "Lisää uusi"
      },
      "multilingual_url": {
        "title": "Käytä monikielistä URL-osoitetta",
        "description": "Jos asetettu Kyllä, URL-osoitetta EI käännetä, mutta sivu pysyy monikielisenä käännetyn sisällön kanssa",
        "live_example_title": "Reaaliaikainen esimerkki",
        "live_example_description": "Lähde-URL: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "Luotu URL: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "Luotu URL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Käytä sääntöä staattiseen sisältöön, dynaamiseen sisältöön tai molempiin",
        "title": "Kohdista sisältöön",
        "all": "Kaikki sisältö",
        "static": "Staattinen sisältö",
        "dynamic": "Dynaaminen sisältö"
      },
      "force_apply_urls": {
        "title_description": "Pakota sääntö kaikkiin URL-osoitteiden käännöksiin myös olemassa oleviin!",
        "title_replace": "Pakota korvaus URL-osoitteissa",
        "title_exclude": "Pakota poissulkeminen URL-osoitteissa",
        "warning": "Varoitus",
        "warning_part1": "Tämän asettaminen \"Kyllä\" voi rikkoa verkkosivustosi URL-osoitteiden käännökset.",
        "warning_part2": "Tämä voi tilapäisesti tai pysyvästi luoda 404-virhesivuja; jatka vain, jos ymmärrät seuraukset.",
        "warning_replacement_original": "Lisävaroitus: Yrität korvata alkuperäistä sisältöä, joka voi vaikuttaa URL-osoitteeseen. Käännös voi epäonnistua, koska Linguise ei löydä alkuperäisiä URL-osoitteita oikein."
      }
    },
    "main": {
      "parent": "Säännöt",
      "edit": "Muokkaa sääntöä",
      "add": "Uusi sääntö"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" ohitetaan sisällössä ja URL-osoitteessa",
      "preview_single": "\"{{text_ignore}}\" ohitetaan sisällössä",
      "preview_more_with_url": "\"{{text_ignore}}\" ja {{count}} muuta ohitetaan sisällössä",
      "preview_more": "\"{{text_ignore}}\" ja {{count}} muuta ohitetaan sisällössä",
      "other_parameters": "Säännölle on asetettu muita parametreja; napsauta muokkauspainiketta saadaksesi lisätietoa"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" korvataan \"{{replacement}}\" sisällössä ja URL-osoitteissa",
      "preview_single": "\"{{original}}\" korvataan \"{{replacement}}\" sisällössä",
      "preview_more_with_url": "\"{{original}}\" korvataan \"{{replacement}}\" sisällössä ja URL-osoitteissa ja {{nb}} muuta",
      "preview_more": "\"{{original}}\" korvataan \"{{replacement}}\" sisällössä ja {{nb}} muuta",
      "other_parameters": "Säännölle on asetettu muita parametreja; napsauta muokkauspainiketta saadaksesi lisätietoa"
    },
    "content_exclusion": {
      "selectors": "{{nb}} CSS-valitsinta on jätetty kääntämättä",
      "other_parameters": "Säännölle on asetettu muita parametreja; napsauta muokkauspainiketta saadaksesi lisätietoa"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URL-osoitetta on jätetty kääntämättä, mutta ne säilyttävät monikielisen etuliitteen",
      "some": "{{nb}} URL-osoitetta on täysin jätetty kääntämättä",
      "all_multilingual": "kaikki URL-osoitteet on jätetty kääntämättä, mutta ne säilyttävät monikielisen etuliitteen",
      "all": "kaikki URL-osoitteet on täysin jätetty kääntämättä",
      "other_parameters": "Säännölle on asetettu muita parametreja; napsauta muokkauspainiketta saadaksesi lisätietoa"
    },
    "ignore_inline": {
      "elements": "Kaikki sisäinen sisältö käännetään sivulla lohkosina",
      "all_elements": "Osa sisäisestä sisällöstä käännetään sivulla lohkosina",
      "other_parameters": "Tälle säännölle on asetettu muita parametreja. Saat lisätietoja napsauttamalla muokkauspainiketta."
    },
    "title": "Sääntöjen hallinta",
    "description": "Hallitse sivustosi käännösten sisältöjen poissulkemisia ja korvauksia",
    "add": "Lisää uusi sääntö",
    "table": {
      "title": "Otsikko",
      "no_data": "Täällä ei ole vielä sääntöjä",
      "type": "Tyyppi",
      "preview": "Säännön esikatselu",
      "action": "Toiminto",
      "delete_confirm": "Vahvista säännön poisto",
      "types": {
        "text_ignore": "Tekstin ohitus",
        "text_replace": "Tekstin korvaus",
        "content_exclusion": "Sisällön poissulkeminen",
        "url_exclusion": "URL-osoitteen poissulkeminen",
        "ignore_inline": "Ohita sisäinen",
        "unknown": "Tuntematon sääntö"
      }
    },
    "apply_on_content": {
      "static": "Tätä sääntöä sovelletaan vain staattiseen sisältöön",
      "dynamic": "Tätä sääntöä sovelletaan vain dynaamiseen sisältöön"
    }
  },
  "search_translations": {
    "title": "Hakulausekkeiden hallinta",
    "description": "Luettele kaikki verkkosivustosi käännökset, joita käytetään hakulomakkeissa (käännetystä kielestä verkkotunnuksesi peruskieleen)",
    "filter_languages": "Suodata kielien mukaan...",
    "filter_original": "Suodata alkuperäisen kielen teksti",
    "filter_translation": "Suodata käännetyn tekstin mukaan",
    "table": {
      "original": "Alkuperäinen",
      "language": "Kieli",
      "translation": "Käännös"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Tilaus epäonnistui!",
      "title": "Tilaus epäonnistui!",
      "subtitle": "Tilauksesi käsittelyssä tapahtui virhe.",
      "home": "Palaa etusivulle",
      "generic": "Tapahtui tuntematon virhe Linguisen puolella, ota yhteyttä ylläpitäjään!"
    },
    "success": {
      "home": "Hallitse verkkotunnuksen käännöksiä",
      "message": "Olemme sitoutuneet tarjoamaan sinulle parhaan mahdollisen käännöskokemuksen. Asiantuntijatiimimme on käytettävissä kaikkiin kysymyksiin ja tukeen. Aloita napsauttamalla alla olevaa painiketta.",
      "subtitle": "Kiitos, että valitsit Linguisen käännöspalvelun",
      "title": "Tilaus aktivoitu!",
      "tab_title": "Kiitos tilauksesta!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "Tilaus aktivoitu!",
      "title": "Tilaus aktivoitu!",
      "subtitle": "Kiitos, että valitsit Linguisen käännöspalvelun",
      "message": "Olemme sitoutuneet tarjoamaan sinulle parhaan mahdollisen käännöskokemuksen. Asiantuntijatiimimme on käytettävissä kaikkiin kysymyksiin ja tukeen. Aloita napsauttamalla alla olevaa painiketta.",
      "home": "Hallitse verkkotunnuksen käännöksiä"
    },
    "edit": {
      "title": "Hallitse tilausta"
    },
    "list": {
      "title": "Tilausluettelo",
      "description": "Luettelo verkkotunnustilauksistasi"
    },
    "table": {
      "domain": "Verkkotunnus",
      "plan": "Paketti",
      "status": "Tila",
      "card": "Kortti",
      "usage": "Käyttö",
      "actions": "Toiminnot",
      "payment_method": "Maksutapa"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} sanaa",
      "paidOffered": "{{words_used}} / {{words_allowed}} sanaa\n(Mukana {{free_words}} tarjottua sanaa)"
    },
    "popup": {
      "dueToday": "Tänään erääntyy yhteensä",
      "nextPeriod": "Alkaen {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Valitse tili"
    }
  },
  "translation": {
    "main": {
      "parent": "Käännökset",
      "edit": "Muokkaa käännöstä"
    },
    "form": {
      "original": {
        "title": "Alkuperäinen kielellä {{language}}"
      },
      "is_inline": "Tämä käännös on tehty sisältöön upotetusta tekstistä.",
      "inline_editor": {
        "count_warning": "Sisäkkäisten alueiden määrä ei vastaa alkuperäistä ({{current}} / {{expected}}).",
        "restore_original": "Palauta alkuperäinen teksti",
        "insert_placeholder": "Lisää paikkamerkki",
        "drag": "Järjestä alue vetämällä",
        "area": "Tekstialue {{index}}",
        "restore": "Palauta puuttuvat sisäkkäiset alueet"
      },
      "translation": {
        "title": "Käännös kielellä {{language}}",
        "description": "Käännös, jonka haluat ohittaa"
      }
    },
    "copy": {
      "title": "Kopioi manuaaliseen käännökseen",
      "label": "Kopioi manuaaliseen"
    },
    "level": {
      "base": {
        "title": "Peruskäännös",
        "subtitle": "Automaattinen · Linguise Cloud -käännös",
        "empty": "Tälle tekstille ei ole peruskäännöstä.",
        "overridden": "Valintasi on tallennettu, mutta sen sijaan näytetään uusin tekoälyllä parannettu käännös, koska “Korvaa manuaaliset ja valitut käännökset” on tekoälykäännöksen asetuksissa arvossa Kyllä. Poista asetus käytöstä, jos haluat käyttää valintaasi."
      },
      "not_generated": "Ei luotu",
      "none": "Ei vielä mitään",
      "ai": {
        "title": "Tekoälyllä parannettu käännös",
        "subtitle": "Automaattinen · Linguise AI",
        "empty_title": "Tälle tekstille ei ole vielä luotu",
        "empty_description": "Linguise AI tuottaa luonnollisempia käännöksiä sivusi ja verkkosivustosi kontekstin avulla. Näin saat sellaisen tähän:",
        "empty_step_1": "Siirry kohtaan Tekoälykäännös › Asetukset ja aseta Ota käännös tekoälyllä käyttöön -asetukseksi “Vain säännöt”, “Vain live-editori” tai “Säännöt ja live-editori”.",
        "empty_step_2": "Ota se käyttöön tähän sivuun sopivalla säännöllä tai sivu kerrallaan Live-editorista.",
        "empty_step_3": "Tekoälyllä parannettu käännös ilmestyy tähän, kun se on luotu. Se kuluttaa tekoälykrediittejäsi.",
        "open_settings": "Avaa tekoälykäännöksen asetukset",
        "open_editor": "Avaa Live-editori",
        "overrides_selection": "Valintasi on tallennettu, mutta sen sijaan näytetään tämä tekoälyllä parannettu käännös, koska “Korvaa manuaaliset ja valitut käännökset” on tekoälykäännöksen asetuksissa arvossa Kyllä. Poista asetus käytöstä, jos haluat käyttää valintaasi.",
        "overrides_version": "Valitsemasi versio on tallennettu, mutta sen sijaan näytetään uusin tekoälyllä parannettu versio, koska “Korvaa manuaaliset ja valitut käännökset” on tekoälykäännöksen asetuksissa arvossa Kyllä. Poista asetus käytöstä, jos haluat käyttää valittua versiota."
      },
      "manual": {
        "title": "Manuaalinen käännös",
        "subtitle": "Itse kirjoittamasi · ensisijainen automaattisiin käännöksiin nähden",
        "empty": "Tyhjä",
        "saved_but_overridden": "Tallennettu valinnaksesi, mutta sitä ei näytetä automaattisesti, koska “Korvaa manuaaliset käännökset” on tekoälykäännöksen asetuksissa arvossa Kyllä: tekoälyllä parannettu käännös on ensisijainen, kunnes asetus poistetaan käytöstä.",
        "ignored": "Sitä ei näytetä automaattisesti, koska “Korvaa manuaaliset käännökset” on tekoälykäännöksen asetuksissa arvossa Kyllä. Valitse se, jos haluat käyttää sitä tälle tekstille.",
        "label": "Oma käännöksesi",
        "placeholder": "Kirjoita oma käännöksesi...",
        "last_updated": "Viimeksi muokattu {{date}}",
        "save_hint": "Manuaalisen käännöksen tallentaminen ottaa sen käyttöön.",
        "delete": "Poista manuaalinen käännös",
        "delete_confirm": "Vahvista manuaalisen käännöksen poisto"
      }
    },
    "history": {
      "title": "Tekoälyllä parannetut versiot",
      "subtitle": "Jokainen Live-editorista tehty uudelleenluonti säilytetään",
      "unknown_model": "Tuntematon malli",
      "current": "Nykyinen",
      "restore": "Palauta tämä versio",
      "restore_note": "Palauttaminen asettaa kyseisen version nykyiseksi tekoälyllä parannetuksi käännökseksi. Mitään ei poisteta.",
      "version_of": "Versio {{current}} / {{total}}",
      "hide": "Piilota historia ({{total}})",
      "show": "Näytä historia ({{total}})"
    },
    "choose": {
      "title": "Käännökset kielelle {{language}} · valitse vierailijoille näkyvä",
      "current": "Tällä hetkellä verkkosivustollasi:",
      "priority": "Oletusjärjestys: manuaalinen › tekoälyllä parannettu › perus. Valintasi tallennetaan vain tälle käännökselle.",
      "reset": "Palauta oletusjärjestys",
      "reset_title": "Unohda valintasi tälle tekstille ja käytä taas oletusjärjestystä",
      "resetting": "Palautetaan..."
    }
  },
  "translations": {
    "title": "Käännösten hallinta",
    "description": "Luettele ja muokkaa kaikki verkkosivustosi käännökset; visuaaliseen käännökseen käytä Live Editoria",
    "filter_languages": "Suodata kielien mukaan...",
    "filter_original": "Suodata alkuperäisen kielen teksti",
    "filter_translation": "Suodata käännetyn tekstin mukaan",
    "table": {
      "original": "Alkuperäinen",
      "language": "Kieli",
      "action": "Toiminto",
      "base": "Perus",
      "ai": "Tekoälyparannettu",
      "manual": "Manuaalinen"
    },
    "filter_exact": "Täsmällinen osuma",
    "badge": {
      "active": "Käytössä",
      "overrides_manual": "Korvaa manuaalisen"
    },
    "cell": {
      "none": "ei mitään",
      "not_generated": "ei luotu",
      "ignored": "Ohitettu – tekoälysääntö voittaa"
    },
    "tabs": {
      "all": "Kaikki",
      "manual": "Manuaalinen",
      "ai": "Tekoälyparannettu",
      "base": "Vain perus"
    },
    "levels_hint": "Jokaisella tekstillä on enintään 3 tasoa – Käytössä-merkitty on se, minkä vierailijat näkevät."
  },
  "url": {
    "main": {
      "parent": "URL-osoitteet",
      "edit": "Muokkaa URL-osoitteen käännöstä"
    },
    "form": {
      "original": {
        "title": "Alkuperäinen kielellä {{language}}"
      },
      "translation": {
        "title": "URL-osoitteen käännös kielellä {{language}}",
        "description": "URL-osoite, jonka haluat ohittaa",
        "placeholder": "URL-osoitteen korvaava käännös",
        "invalid_full": "Yrität vaihtaa virheelliseen muotoon; sinun tulisi vaihtaa vain URL-osoitteen tunnisteet/polku",
        "invalid": "Virheellinen URL-osoite/polku"
      }
    }
  },
  "urls": {
    "title": "URL-osoitteiden hallinta",
    "description": "Luettele ja muokkaa kaikkia verkkosivustosi URL-osoitteiden käännettyjä sisältöjä (edistynyt; varo 404-virheitä)",
    "filter_languages": "Suodata kielien mukaan...",
    "filter_original": "Suodata alkuperäisen kielen teksti",
    "filter_translation": "Suodata käännetyn tekstin mukaan",
    "table": {
      "original": "Alkuperäinen",
      "language": "Kieli",
      "url": "Käännetty URL-osoite",
      "action": "Toiminto",
      "edited": "Alkuperäistä käännöstä on muokattu"
    }
  }
}
